import React from "react";
import desertBg from "../images/desert-bg.jpg"; // permanece en src/

const LAT = -32.23348;
const LNG = -71.485504;

const ADDRESS =
  "Uno Norte, Parcela 24, Los Molles, Santa María, Provincia de Petorca, Valparaíso, Chile";


  
  
const MAP_EMBED_SRC = `https://www.google.com/maps?q=${LAT},${LNG}&hl=es&z=16&output=embed`;
const MAP_EXTERNAL = `https://www.google.com/maps/search/?api=1&query=${LAT},${LNG}`;

export default function Location() {
  return (
    <section
      id="donde-estamos"
      className="relative py-20"
      style={{
        position: "relative",
        backgroundImage: `url(${desertBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        zIndex: 0,
      }}
    >
      {/* Overlay translúcido */}
      <div
        className="absolute inset-0 bg-white/80 backdrop-blur-[2px]"
        style={{ zIndex: 1 }}
      />

      {/* Contenido sobre el fondo */}
      <div
        className="relative max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center"
        style={{ zIndex: 2 }}
      >
        {/* Mapa */}
        <div className="rounded-2xl overflow-hidden shadow-lg border">
          <iframe
            title="Ubicación Parcela"
            src={MAP_EMBED_SRC}
            width="100%"
            height="380"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* Texto lateral */}
        <div className="text-gray-800 bg-white/60 p-6 rounded-2xl shadow-sm">
          <h2 className="text-3xl font-semibold mb-4">¿Dónde está la Pérgola del Sol?</h2>

          <p className="mb-2">
            <span className="font-medium">Dirección:</span> {ADDRESS}
          </p>
          <p className="mb-2">
            <span className="font-medium">Coordenadas:</span>{" "}
            {LAT.toFixed(6)}, {LNG.toFixed(6)}
          </p>


          <a
            href={MAP_EXTERNAL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-blue-600 text-blue-600 hover:bg-blue-50 transition"
          >
            Abrir en Google Maps
          </a>
        </div>
      </div>
    </section>
  );
}
